// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

// The task conversation's own strings. They live under `shared/` rather than in
// either domain catalogue because `TaskConversationThread.vue` is mounted by BOTH
// surfaces — the practice's task detail and the client's portal task — and one
// thread rendered from two catalogues would be one thread that could be worded
// two ways (`BR-05`).
//
// The wording is deliberately side-neutral. "Message", never "note" or
// "instruction": both parties write here, and a label that assumed the
// accountant was speaking would read as an error to the client half the time.

export default {
    'tasks.conversation.heading': 'Conversation',
    'tasks.conversation.loading': 'Loading the conversation…',
    'tasks.conversation.empty': 'No messages yet.',
    'tasks.conversation.error': 'We could not load the conversation. Try again.',
    'tasks.conversation.composerLabel': 'Write a message',
    'tasks.conversation.send': 'Send message',
    'tasks.conversation.sending': 'Sending your message…',
    'tasks.conversation.sent': 'Message sent.',
    'tasks.conversation.failed': 'We could not send your message. Try again.',

    // Who wrote a message. `you` is whichever side is reading — seeing your own
    // name quoted back at you reads like somebody else wrote it. The two side
    // labels are the fallback for a message whose author has since been removed
    // from the platform: the speaker is still known even when the person is not.
    'tasks.conversation.you': 'You',
    'tasks.conversation.practiceSide': 'Your accountant',
    'tasks.conversation.clientSide': 'Your client',
};
